import { useObservableWithCallback } from '@office-start/use-observable-hook-utility';
import { useEffect } from 'react';
import { m365AppDefinitionsBehaviorSubject } from '../state';
import { setupM365AppsConfigService } from '../utils';
import { useRegisterMosAppActions } from './useRegisterMosAppActions';
/**
 * @description Get all M365 Application definitions (app service via config service + side loaded)
 * @returns An array of HarmonyAppDefinition
 * @todo Convert this from an observable to a React Query
 */
export var useAppDefinitions = function () {
    useEffect(function () {
        setupM365AppsConfigService();
    }, []);
    var registerMosAppActions = useRegisterMosAppActions();
    var m365AppDefinitions = useObservableWithCallback(m365AppDefinitionsBehaviorSubject, registerMosAppActions);
    if (m365AppDefinitions === null) {
        return [];
    }
    return m365AppDefinitions;
};
//# sourceMappingURL=useAppDefinitions.js.map